// extracted by mini-css-extract-plugin
export default {"button":"themedButton_button__k5M-y","compact":"themedButton_compact__-HI5I"};